import { Badge, Button, Dropdown } from 'antd';
import {
  accordionCloseIcon,
  accordionOpenIcon,
  backIcon,
  logoIcon,
  notifyIcon,
  userIcon,
} from 'assets';
import axios from 'axios';
import { useAppDispatch } from 'hooks';
import { routes } from 'navigations/routers';
import { userData } from 'pages/Login/selectors';
import { logout } from 'pages/Login/slice';
import { FC, ReactDOM, useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { generatePath, Link, useHistory, useLocation } from 'react-router-dom';
import { workerService } from 'services';
// import MenuUser from './MenuUser';
import { useFormik } from 'formik';
import { userRole } from '../../constant';
import SectionStyled, {
  CenterStyled,
  HeaderStyled,
  LeftStyled,
  MenuDropdownUserStyled,
  RightStyled,
  SpaceOffset,
  TabSelectStyled,
  UserInfoWrapper,
} from './styles';
import BranchSelect from './ModalSelect';
import { layoutSelector } from './selectors';
import { getBranchs, selectBranch } from './thunk';
export type LayoutProps = {
  tabs?: { label: string; key: number | string }[];
  defaultValue?: number | string;
  onSelected?: (key: number | string) => void;
  left?: boolean | JSX.Element;
  back?: boolean;
  right?: boolean;
  showNotification?: boolean;
  showButtonBranchSelect?: boolean;
  visibleModal?: boolean;
  contenModal?: ReactDOM;
};

const Layout: FC<LayoutProps> = ({
  showNotification = true,
  tabs,
  defaultValue,
  onSelected,
  left,
  back,
  right,
}) => {
  const history = useHistory();
  const { state, pathname } = useLocation<{ openModalSelectBranch: boolean }>();
  const { branchs } = useSelector(layoutSelector);

  // const { user: userProfile } = useSelector(layoutSelector);
  const { user_name, user_id, roleUser } = useSelector(userData);
  const [visibleDropdown, setVisibleDropdown] = useState<boolean>(false);
  const [visibleModalBranchs, setVisibleModalBranchs] = useState<boolean>(false);
  const [notifyCount, setNotifyCount] = useState<number>(0);
  const { kengen_code } = useSelector(userData);
  const branchSelect = localStorage.getItem('branchSelect');
  const dispatch = useAppDispatch();
  useEffect(() => {
    // dispatch(getUserProfile({}));
    if (roleUser === userRole.CM) {
      return;
    }
    (async () => {
      const { data } = await workerService.getInformation({});
      setNotifyCount(data.unread_count);
    })();
  }, [dispatch, roleUser]);
  const formik = useFormik({
    initialValues: {
      branch: branchSelect ? JSON.parse(branchSelect) : '',
    },
    enableReinitialize: true,
    async onSubmit(values) {
      try {
        const branch = await branchs.find((i) => i.key === values.branch);
        setVisibleModalBranchs(false);
        await localStorage.setItem('branchSelect', JSON.stringify(values.branch));
        branch &&
          user_id &&
          dispatch(
            selectBranch({
              ...branch,
              user_id,
            })
          );
        history.replace({
          pathname: history.location.pathname,
          state: { openModalSelectBranch: false },
        });
        setVisibleDropdown(false);
        // history.go(0);
      } catch (error) {
        console.log(error);
      }
    },
  });
  const handleLogout = useCallback(async () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('role');
    localStorage.removeItem('user_name');
    localStorage.removeItem('cooperator_id');
    localStorage.removeItem('branchSelect');
    await delete axios.defaults.headers.common['Authorization'];
    await dispatch(logout());
  }, [dispatch]);
  const eUserId = useRef(null);

  useEffect(() => {
    let isLoad = true;
    if (isLoad && kengen_code && ['A6', 'A7'].includes(kengen_code) && !branchSelect) {
      setVisibleModalBranchs(true);
      (async () => {
        await dispatch(getBranchs());
        isLoad = false;
      })();
    }
    if (state?.openModalSelectBranch && branchSelect) {
      dispatch(getBranchs());
    }
    return () => {
      isLoad = false;
    };
  }, [branchSelect, dispatch, kengen_code, state?.openModalSelectBranch]);
  return (
    <>
      <SectionStyled>
        <HeaderStyled>
          <LeftStyled>
            {left === true ? (
              back ? (
                <Button
                  type="text"
                  className="btn-back"
                  icon={<img src={backIcon} alt="back-icon" className="mr-16" />}
                  onClick={history.goBack}
                >
                  {right ? (
                    <span className="fs-16 fw-6">現場一覧</span>
                  ) : (
                    <span className="fs-16 fw-6">戻る</span>
                  )}
                </Button>
              ) : (
                <div className="cursor-pointer d-flex" onClick={() => history.push('/')}>
                  <img className="logo-header " src={logoIcon} alt="logo" />
                </div>
              )
            ) : (
              left
            )}
          </LeftStyled>
          <CenterStyled>
            {tabs?.map((tab) => (
              <TabSelectStyled
                key={tab.key}
                className={defaultValue === tab.key ? 'tab-selected' : ''}
                onClick={() => onSelected && onSelected(tab.key)}
              >
                <span className="text">{tab.label}</span>
              </TabSelectStyled>
            ))}
          </CenterStyled>
          <RightStyled>
            {right && (
              <>
                {showNotification && (
                  <Link
                    className="notify-header"
                    to={generatePath(routes.Notifications.path, { entity: 'receiving' })}
                  >
                    <Badge className="badge" count={notifyCount}>
                      <img src={notifyIcon} alt="notify-icon" />
                    </Badge>
                    <span className="ml-8">連絡事項</span>
                  </Link>
                )}
                {pathname !== '/login' && (
                  <UserInfoWrapper ref={eUserId}>
                    <Dropdown
                      overlay={
                        <MenuDropdownUserStyled>
                          {kengen_code && ['A6', 'A7'].includes(kengen_code) && (
                            <MenuDropdownUserStyled.Item
                              className="fw-3 fs-16 menu-item"
                              key="2"
                              onClick={() => {
                                history.replace({
                                  pathname: history.location.pathname,
                                  state: { openModalSelectBranch: true },
                                });
                                setVisibleModalBranchs(true);
                              }}
                            >
                              支店選択画面に戻る
                            </MenuDropdownUserStyled.Item>
                          )}
                          <MenuDropdownUserStyled.Item
                            className="fw-3 fs-16 menu-item"
                            key="3"
                            onClick={handleLogout}
                          >
                            ログアウト
                          </MenuDropdownUserStyled.Item>
                        </MenuDropdownUserStyled>
                      }
                      trigger={['click']}
                      placement="bottomRight"
                      className={`d-flex `}
                      visible={visibleDropdown}
                      getPopupContainer={(eUserId) => eUserId}
                      overlayStyle={{ maxWidth: '240px' }}
                      onVisibleChange={(visible) => setVisibleDropdown(visible)}
                    >
                      <div>
                        <img src={userIcon} alt="user-icon" />
                        <div className="user-info">{user_name || ''}</div>
                        {visibleDropdown ? (
                          <img
                            src={accordionCloseIcon}
                            alt="accordionCloseIcon-icon"
                            style={{ opacity: '0.5' }}
                          />
                        ) : (
                          <img src={accordionOpenIcon} alt="accordionOpenIcon-icon" />
                        )}
                      </div>
                    </Dropdown>
                  </UserInfoWrapper>
                )}
              </>
            )}
          </RightStyled>
        </HeaderStyled>
      </SectionStyled>
      <SpaceOffset />
      <BranchSelect
        formik={formik}
        maskClosable={!!branchSelect}
        visibleModal={state?.openModalSelectBranch || visibleModalBranchs}
        setVisible={(e) => {
          formik.resetForm();
          history.replace({
            pathname: history.location.pathname,
            state: { openModalSelectBranch: e },
          });
          setVisibleModalBranchs(e);
        }}
        data={branchs.map((branch) => ({
          key: (branch?.key ?? '').toString(),
          label: `(${branch?.kyoten_code})${branch?.kyoten_name}` ?? '',
        }))}
        name="branch"
      />
    </>
  );
};

export default Layout;
